// client/src/App.js

import {
  AlertDialog,
  AlertDialogBody, AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader, AlertDialogOverlay,
  Box,
  Button,
  Center,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Progress,
  Select,
  Spinner,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Tfoot,
  Th,
  Thead,
  Tr,
  HStack,
  useToast,
  Badge,
  Image,
  Grid,
  GridItem
} from '@chakra-ui/react';
import {
  Link
} from "react-router-dom";
import axios from "axios";
import React, { useEffect, useState, useRef } from 'react';
import { AiFillStepBackward, AiFillStepForward, AiFillEye, AiFillStar } from "react-icons/ai";
import { MdAdd, MdDelete, MdEdit } from "react-icons/md";
import "../../App.css";
import CommonContext from '../../commonContext';
import { postCall } from '../../utils/requests';
import Utils from '../../utils/utils';
import { HiOutlineBadgeCheck } from "react-icons/hi";
import { utilConstants } from '../../utils/utilConstants';
import { FaSortDown, FaSortUp } from "react-icons/fa";
import { BsSortUp } from "react-icons/bs";

function VideoList() {

  /* TODO const navigate = useNavigate(); */
  const commonContext = React.useContext(CommonContext);

  const logout = () => {
    console.log("logout")
    localStorage.removeItem("accessToken");
    /* TODO navigate('/'); */
  }

  /* utils */
  const toast = useToast();
  const fileRef = React.useRef(null);

  /* table */
  const [tableContent, setTableContent] = useState([]);
  const [allData, setAllData] = useState([]);

  /* delete form */
  const [isOpenDelete, setIsOpenDelete] = React.useState(false)
  const [isOpenCreate, setIsOpenCreate] = React.useState(false)
  const [isOpenEdit, setIsOpenEdit] = React.useState(false)
  const [idToDelete, setIdToDelete] = React.useState(null)
  const [idToUpdate, setIdToUpdate] = React.useState(null)
  const [nameToDelete, setNameToDelete] = React.useState("")
  const [page, setPage] = React.useState(1)
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(null);
  const [title, setTitle] = useState("");
  const [linkYt, setLinkYt] = useState("");
  const [linkVimeo, setLinkVimeo] = useState("");
  const [description, setDescription] = useState("");
  const [longDescription, setLongDescription] = useState("");
  const [hidden, setHidden] = useState(false);
  const [premium, setPremium] = useState(false);
  const [idCategory, setIdCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [updatedChunks, setUpdatedChunks] = useState(0);
  const [totalChunks, setTotalChunks] = useState(0);
  const [allCategories, setAllCategories] = useState([]);
  const [search, setSearch] = useState("");
  const [defaultCat, setDefaultCat] = useState("-1");
  const [toplist, setToplist] = useState(false);
  const [coverPath, setCoverPath] = useState("")
  const [sortOrder, setSortOrder] = React.useState("desc")
  const [sortedBy, setSortedBy] = React.useState("")
  const [startDate, setStartDate] = React.useState(null)

  const handleFileChange = (event) => {
    setVideo(event.target.files[0]);
  };

  /* BEGIN - video cover */
  const handleVideoCoverChange = async (event) => {

    /* formdata */
    let formData = new FormData();

    //add fields to form
    //formData.append('video', video);
    formData.append('action', 'add')
    formData.append("file", event.target.files[0])

    try {

      const response = await axios.post('/uploadVideoCover', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 0,

      });


      if (response.data.status === "success") {
        /* TODO set iamge url here */
        console.log("uploaded_success")

        setCoverPath(response.data.data.coverPath)
      } else {
        /* TODO STOP PROCESS */
        console.log("upload_error")
      }
    } catch (error) {
      console.log(error)
    }

  };

  /* END - video cover */


  const handleSubmitVideo = async (event) => {
    event.preventDefault();

    if (title === "" || title === null || title === undefined) {
      toast({
        title: "Errore",
        description: "Scegli un titolo",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return;
    }

    if (idCategory === null) {
      toast({
        title: "Errore",
        description: "Scegli una categoria",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return;
    }

    setLoading(true);
    onCloseCreate()

    try {
      let resp = await postCall("/createVideo", {
        title: title,
        description: description,
        long_description: longDescription,
        hidden: hidden,
        premium: premium,
        id_category: idCategory,
        toplist: toplist,
        image_path: coverPath ?? "",
        external_path: linkYt,
        vimeo_link: linkVimeo

      })
      if (resp !== undefined && resp !== null && resp.status === "success") {
        toast({
          title: "Perfetto",
          description: "I video sono stati aggiornati",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        setLoading(false);
        fetchVideos()
      } else {
        toast({
          title: "Errore",
          description: "Si è verificato un errore: " + resp.error,
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        setLoading(false);
      }
    } catch (e) {
      toast({
        title: "Errore",
        description: "Si è verificato un errore",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      setLoading(false);
    }


  };

  const fetchCategories = async () => {
    postCall("/fetchCat", {}).then((data) => {

      setAllCategories(data.data)
      setCategories(Array.from(data.data.map((item) => {
        return (<option key={item.id_category} value={item.id_category}>{item.name}</option>)
      })));
    });
  }

  const updateVideos = async () => {
    postCall("/updateFromLocalVideos", {}).then((data) => {
      console.log(data);
      if (data.status === "success") {
        toast({
          title: "Perfetto",
          description: "I video sono stati aggiornati",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        fetchVideos()
      } else {
        toast({
          title: "Errore",
          description: "Si è verificato un errore: " + data.error,
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });
  }

  const setDefaultCategory = async (id_category) => {

    setDefaultCat(id_category)


    /*  setCategories(Array.from(allCategories.map((item) => {
 
       console.log(item.id_category, id_category)
       if (item.id_category === id_category) {
         return (<option selected key={item.id_category} value={item.id_category}>{item.name}</option>)
       } else {
         return (<option key={item.id_category} value={item.id_category}>{item.name}</option>)
       }
     }))); */
  }


  const fetchVideos = async () => {
    postCall("/fetchVideos", {}).then((data) => {


      if (data.status === "success") {




        setAllData(Array.from(data.data.map((item) => {



          return {
            id: item.id_video,
            title: item.title,
            description: item.description,
            long_description: item.long_description,
            category_name: item.category_name,
            premium: item.premium,
            hidden: item.hidden,
            id_category: item.id_category,
            toplist: item.toplist,
            image_path: item.image_path,
            created_at: Utils.convertDateToIta(item.created_on, false),
            creation_date: item.created_on,
            external_path: item.external_path,
            vimeo_link: item.vimeo_link

          }
        })));

        /* put in tableContent only first n element from allData */
        setTableContent(Array.from(data.data.map((item) => {
          return {
            id: item.id_video,
            title: item.title,
            description: item.description,
            long_description: item.long_description,
            category_name: item.category_name,
            premium: item.premium,
            hidden: item.hidden,
            id_category: item.id_category,
            toplist: item.toplist,
            image_path: item.image_path,
            created_at: Utils.convertDateToIta(item.created_on, false),
            creation_date: item.created_on,
            external_path: item.external_path,
            vimeo_link: item.vimeo_link

          }
        })).slice((page * 7) - 7, (page * 7)));

      } else {
        toast({
          title: "Errore",
          description: "Errore nel recupero video",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }
    });
  }

  useEffect(() => {

    fetchVideos()
    fetchCategories()

    commonContext.setCurrentPath("Video")
    commonContext.setCurrentPage("videolist")

    return () => {
      // Clean up the interval on component unmount
      clearInterval(timer);
    };

  }, []);


  /* BEGIN - SORTABLE */

  const handleSortCategory = () => {
    setSortedBy("category")
    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => (a.category_name ?? "").localeCompare(b.category_name ?? ""))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => (b.category_name ?? "").localeCompare(a.category_name ?? ""));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {
      /* console.log("item: ", item) */

      return {
        id: item.id,
        title: item.title,
        description: item.description,
        long_description: item.long_description,
        category_name: item.category_name,
        premium: item.premium,
        hidden: item.hidden,
        id_category: item.id_category,
        toplist: item.toplist,
        image_path: item.image_path,
        created_at: item.created_at,
        creation_date: item.creation_date,
        external_path: item.external_path,
        vimeo_link: item.vimeo_link
      }
    })).slice((page * 7) - 7, (page * 7)));
  };

  const handleSortCreated = () => {
    setSortedBy("created")

    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.creation_date.localeCompare(b.creation_date))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.creation_date.localeCompare(a.creation_date));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {

      return {
        id: item.id,
        title: item.title,
        description: item.description,
        long_description: item.long_description,
        category_name: item.category_name,
        premium: item.premium,
        hidden: item.hidden,
        id_category: item.id_category,
        toplist: item.toplist,
        image_path: item.image_path,
        created_at: item.created_at,
        creation_date: item.creation_date,
        external_path: item.external_path,
        vimeo_link: item.vimeo_link

      }
    })).slice((page * 7) - 7, (page * 7)));
  };

  const handleSortTitle = () => {
    setSortedBy("title")

    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.title.localeCompare(b.title))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.title.localeCompare(a.title));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {

      return {
        id: item.id,
        title: item.title,
        description: item.description,
        long_description: item.long_description,
        category_name: item.category_name,
        premium: item.premium,
        hidden: item.hidden,
        id_category: item.id_category,
        toplist: item.toplist,
        image_path: item.image_path,
        created_at: item.created_at,
        creation_date: item.creation_date,
        external_path: item.external_path,
        vimeo_link: item.vimeo_link

      }
    })).slice((page * 7) - 7, (page * 7)));
  };

  /* END - SORTABLE */



  /* BEGIN - EDIT FORM */

  const handleSubmitEdit = async (event) => {
    event.preventDefault();

    if (title === "" || title === null || title === undefined) {
      toast({
        title: "Errore",
        description: "Scegli un titolo",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return;
    }

    if (idCategory === null) {
      toast({
        title: "Errore",
        description: "Scegli una categoria",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return;
    }

    postCall("/updateVideo", {
      title: title,
      description: description,
      long_description: longDescription,
      hidden: hidden,
      premium: premium,
      id_category: idCategory,
      id_video: idToUpdate,
      toplist: toplist,
      image_path: coverPath ?? "",
      external_path: linkYt,
      vimeo_link: linkVimeo

    }).then((data) => {
      if (data.status === "success") {

        fetchVideos()
        setTitle("")
        setDescription("")
        setLongDescription("")
        setHidden(false)
        setPremium(false)
        setIdCategory(null)
        setIdToUpdate(null)
        setLinkYt("")
        setLinkVimeo("")

        toast({
          title: "Perfetto",
          description: "Video modificato",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        onCloseEdit()

      } else {
        toast({
          title: "Errore",
          description: data.error === "15" ? "Questo nome esiste già" : "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });

  }

  const onCloseEdit = async () => {
    setIsOpenEdit(false)
  }

  const openEdit = async (id, title, description, longDescription, premium, hidden, id_category, category_name, toplist, image_path, external_path, vimeo_link) => {
    setTitle(title)
    setDescription(description)
    setLongDescription(longDescription)
    setHidden(hidden)
    setPremium(premium)
    setIdCategory(id_category)
    setDefaultCategory(id_category)
    setToplist(toplist)
    setCoverPath(image_path)
    setLinkYt(external_path)
    setLinkVimeo(vimeo_link)
    setIsOpenEdit(true)
  }
  /* END - EDIT FORM */


  /* BEGIN - CREATE FORM */

  const onCloseCreate = async () => {
    setIsOpenCreate(false)
  }

  const openCreate = async (id, name) => {
    console.log("openCreate")
    setTitle("")
    setDescription("")
    setLongDescription("")
    setHidden(false)
    setPremium(false)
    setToplist(false)
    setIdCategory(null)
    setDefaultCategory("-1")
    setCoverPath("")
    setIsOpenCreate(true)
  }
  /* END - CREATE FORM */


  /* BEGIN - DELETE FORM */
  const deleteVideo = async () => {
    console.log("onCloseDelete")


    setIsOpenDelete(false)
    postCall("/deleteVideo", {
      id_video: idToDelete
    }).then((data) => {
      if (data.status === "success") {

        /* remove the deleted category from the list */
        setTableContent(tableContent.filter((item) => item.id !== idToDelete))
        setIdToDelete(null)
        setNameToDelete("")

        toast({
          title: "Perfetto",
          description: "Video eliminato",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        fetchVideos()
      } else {
        toast({
          title: "Errore",
          description: "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });
  }

  const onCloseDelete = async () => {
    setIsOpenDelete(false)
  }

  const openDelete = async (id, name) => {
    console.log("openDelete")
    setIdToDelete(id)
    setNameToDelete(name)
    setIsOpenDelete(true)
  }
  /* END - DELETE FORM */

  return (
    <div style={{ "width": "100%", textAlign: "center", height: "100%", overflowY: "scroll" }}>
      {/* BEGIN - FORM TO EDIT A VIDEO */}
      <Modal isOpen={isOpenEdit} onClose={onCloseEdit}>
        <ModalOverlay />
        <ModalContent maxW="900px">
          <ModalHeader>Modifica video</ModalHeader>
          <ModalCloseButton />
          <ModalBody >
            <form onSubmit={handleSubmitEdit}>

              {/* <button type="submit">Upload</button> */}
              <FormControl id="videoName">
                <Grid templateRows="repeat(2, 1fr)" templateColumns="repeat(2, 1fr)" gap={4}>
                  <GridItem rowSpan={1} colSpan={2} >
                    <FormLabel mt="25px">Link YouTube</FormLabel>
                    <Input
                      type="text"
                      value={linkYt}
                      onChange={(event) => setLinkYt(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={2} >
                    <FormLabel mt="25px">Link Vimeo</FormLabel>
                    <Input
                      type="text"
                      value={linkVimeo}
                      onChange={(event) => setLinkVimeo(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1}>
                    <FormLabel
                      mt="25px"
                    >Categoria</FormLabel>
                    <Select
                      defaultValue={defaultCat}
                      onChange={(event) => setIdCategory(event.target.value)}
                      placeholder='Seleziona una categoria'>
                      {categories}
                    </Select>
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="25px">Titolo</FormLabel>
                    <Input
                      type="text"
                      value={title}
                      onChange={(event) => setTitle(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >





                    <FormLabel mt="15px">Sottotitolo</FormLabel>
                    <Input
                      mb="20px"
                      type="text"
                      value={description}
                      onChange={(event) => setDescription(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="15px">Descrizione</FormLabel>
                    <Textarea
                      mb="20px"
                      type="text"
                      value={longDescription}
                      onChange={(event) => setLongDescription(event.target.value)}
                    />

                  </GridItem>
                  <GridItem rowSpan={1} colSpan={2} >
                    <Flex justifyContent="center" alignItems="center" height="100%">


                      <Checkbox
                        mr="40px"
                        isChecked={premium}
                        onChange={(e) => setPremium(e.target.checked)}
                      >
                        Premium
                      </Checkbox>
                      <Checkbox
                        mr="40px"
                        isChecked={hidden}
                        onChange={(e) => setHidden(e.target.checked)}
                      >
                        Nascosto
                      </Checkbox>

                      <Checkbox
                        isChecked={toplist}
                        onChange={(e) => setToplist(e.target.checked)}
                      >
                        In evidenza
                      </Checkbox>
                    </Flex>
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={2} >


                    {/* BEGIN - video cover */}
                    <FormLabel mt="35px">Copertina</FormLabel>
                    <input type="file" name="videoCover" id="videoCover" onChange={handleVideoCoverChange} />

                    {coverPath !== "" && coverPath !== null && coverPath !== undefined &&
                      (<Box>
                        <Flex justifyContent="center" alignItems="center" height="100%">
                          <Image maxWidth="200" justifyContent="center" src={utilConstants.serverBaseURL + coverPath.replaceAll("images/", "")} alt='Immagine di copertina' />
                        </Flex>
                      </Box>)
                    }
                    {/* END - video cover */}
                  </GridItem>

                </Grid>
              </FormControl>
            </form>
          </ModalBody>
          <ModalFooter mt="10px">
            <Button onClick={onCloseEdit} mr={3}>Indietro</Button>
            <Button type="submit" colorScheme="green" onClick={handleSubmitEdit}>Modifica video</Button>

          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* END - FORM TO EDIT A VIDEO */}

      {/* BEGIN - FORM TO CREATE A NEW VIDEO */}
      <Modal isOpen={isOpenCreate} onClose={onCloseCreate}>
        <ModalOverlay />
        <ModalContent maxW="900px">
          <ModalHeader>Carica un nuovo video</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form>

              {/* <button type="submit">Upload</button> */}
              <FormControl id="categoryName">

                <Grid templateRows="repeat(2, 1fr)" templateColumns="repeat(2, 1fr)" gap={4}>
                  {/* <GridItem rowSpan={1} colSpan={2} >
                    <FormLabel>Seleziona il file</FormLabel>
                    <input type="file" name="video" id="video" onChange={handleFileChange} />
                  </GridItem> */}
                  <GridItem rowSpan={1} colSpan={2} >
                    <FormLabel mt="25px">Link YouTube</FormLabel>
                    <Input
                      type="text"
                      value={linkYt}
                      onChange={(event) => setLinkYt(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={2} >
                    <FormLabel mt="25px">Link Vimeo</FormLabel>
                    <Input
                      type="text"
                      value={linkVimeo}
                      onChange={(event) => setLinkVimeo(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >


                    <FormLabel
                      mt="15px"
                    >Categoria</FormLabel>
                    <Select

                      onChange={(event) => setIdCategory(event.target.value)}
                      placeholder='Seleziona una categoria'>
                      {categories}
                    </Select>
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="25px">Titolo</FormLabel>
                    <Input
                      type="text"
                      value={title}
                      onChange={(event) => setTitle(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="15px">Sottotitolo</FormLabel>
                    <Input
                      mb="20px"
                      type="text"
                      value={description}
                      onChange={(event) => setDescription(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >

                    <FormLabel mt="15px">Descrizione</FormLabel>
                    <Textarea
                      mb="20px"
                      type="text"
                      value={longDescription}
                      onChange={(event) => setLongDescription(event.target.value)}
                    />

                  </GridItem>
                  <GridItem rowSpan={1} colSpan={2} >

                    <Flex justifyContent="center" alignItems="center" height="100%">

                      <Checkbox
                        mr="40px"
                        isChecked={premium}
                        onChange={(e) => setPremium(e.target.checked)}
                      >
                        Premium
                      </Checkbox>
                      <Checkbox
                        mr="40px"
                        isChecked={hidden}
                        onChange={(e) => setHidden(e.target.checked)}
                      >
                        Nascosto
                      </Checkbox>

                      <Checkbox
                        isChecked={toplist}
                        onChange={(e) => setToplist(e.target.checked)}
                      >
                        In evidenza
                      </Checkbox>
                    </Flex>
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={2} >


                    {/* BEGIN - video cover */}
                    <FormLabel mt="35px">Copertina</FormLabel>
                    <input type="file" name="videoCover" id="videoCover" onChange={handleVideoCoverChange} />

                    {coverPath !== "" && coverPath !== null && coverPath !== undefined &&
                      (<Box>
                        <Flex justifyContent="center" alignItems="center" height="100%">
                          <Image maxWidth="200" justifyContent="center" src={utilConstants.serverBaseURL + coverPath.replaceAll("images/", "")} alt='Immagine di copertina' />
                        </Flex>
                      </Box>)
                    }

                    {/* END - video cover */}
                  </GridItem>
                </Grid>
              </FormControl>
            </form>
          </ModalBody>
          <ModalFooter mt="10px">
            <Button onClick={onCloseCreate} mr={3}>Indietro</Button>
            <Button type="submit" colorScheme="green" onClick={handleSubmitVideo}>Carica video</Button>

          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* END - FORM TO CREATE A NEW VIDEO */}

      {/* BEGIN - BACK BUTTON */}
      {/* <Stack mt="5" ml="2" mb="5" mr="15" direction='row' spacing={4}>
        <Center><IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          icon={<IoMdArrowRoundBack />}
        /></Center>
        <Box w="5%"></Box>
        <Center >
          <Text
            fontSize="4xl"
            as="b"
            color="teal">
            {commonContext.currentPath}
          </Text>
        </Center>
      </Stack> */}
      {/* END - BACK BUTTON */}

      <hr></hr>

      {/* BEGIN - TOP ROW */}
      <Stack pr="20px" mt="2%" ml="2" mb="10" direction='row' spacing={4} justifyContent="space-between">

        <Flex justifyContent="left" w="100%" >
          <Button  mr="20px"leftIcon={<MdAdd />} colorScheme='green' variant='solid' onClick={openCreate}>
            Carica nuovo video
          </Button>
          <Link to="/sortVideos">
            <Button leftIcon={<BsSortUp />} colorScheme='orange' variant='solid' >
              Modifica ordine
            </Button>
          </Link>
        </Flex>
        {/* <Button ml="20" leftIcon={<MdAdd />} colorScheme='green' variant='solid' onClick={updateVideos}>
          AGGIORNA
        </Button> */}
        <Input
          borderColor="black"
          w="20%"
          placeholder="Cerca..."
          type="text"
          value={search}
          onChange={(event) => {
            setSearch(event.target.value)
            setTableContent(allData.filter((item) => item.title.toLowerCase().includes(event.target.value.toLowerCase())))
          }}
        />
      </Stack>
      {/* END - TOP ROW */}

      {/* BEGIN - Legend */}

      <Flex ml="2" mb="5px">
        <HStack>
          <Text fontSize="md" as="b" color="teal">Legenda:</Text>
          <IconButton
            colorScheme='orange'
            aria-label='Call Segun'
            size="sm"
            icon={<HiOutlineBadgeCheck size={20} />}
          /> <Text fontSize="sm" color="teal" > = Premium, </Text> <IconButton
            colorScheme='yellow'
            aria-label='Call Segun'
            size="sm"
            icon={<AiFillEye size={20} color="white" />}
          />  <Text fontSize="sm" color="teal" >= Nascosto, </Text> <IconButton
            colorScheme='green'
            aria-label='Call Segun'
            size="sm"
            icon={<AiFillStar size={20} />}
          />  <Text fontSize="sm" color="teal" >= In evidenza </Text>
        </HStack>
      </Flex>
      {/* END - Legend */}

      {/* BEGIN - DELETE FROM */}
      <AlertDialog
        isOpen={isOpenDelete}
        onClose={onCloseDelete}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Elimina video
            </AlertDialogHeader>

            <AlertDialogBody>
              Vuoi eliminare definitivamente il video "{nameToDelete}"?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={onCloseDelete}>
                Indietro
              </Button>
              <Button colorScheme='red' onClick={deleteVideo} ml={3}>
                Elimina
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      {/* END - DELETE FORM */}
      {allData.length < 1 && <Flex h="300px" alignItems="center" justifyContent="center">
        <Text fontSize="xl" as="b" color="teal">Nessun video</Text>
      </Flex>}
      {/* BEGIN - TABLE */}
      {allData.length > 0 && <TableContainer h="100%" >
        <Table variant='striped' colorScheme='blue' w="100%" sx={{ tableLayout: "fixed" }}>
          {/* <TableCaption>Elenco delle categorie</TableCaption> */}
          <Thead>
            <Tr>
              <Th w="5%">ID</Th>
              <Th w="18%" _hover={{ cursor: "pointer" }} onClick={handleSortTitle}>Titolo    {sortedBy === "title" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "title" && sortOrder === "desc" && <FaSortUp />}</Th>
              <Th w="12%" >Sottotitolo</Th>
              <Th w="12%" >Descrizione</Th>
              <Th w="10%" _hover={{ cursor: "pointer" }} onClick={handleSortCategory}>Categoria    {sortedBy === "category" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "category" && sortOrder === "desc" && <FaSortUp />}</Th>
              <Th w="3%"><IconButton
                colorScheme='orange'
                aria-label='Call Segun'
                size="sm"
                icon={<HiOutlineBadgeCheck size={20} />}
              /></Th>
              <Th w="3%"><IconButton
                colorScheme='yellow'
                aria-label='Call Segun'
                size="sm"
                icon={<AiFillEye size={20} color="white" />}
              /></Th>
              <Th w="3%"><IconButton
                colorScheme='green'
                aria-label='Call Segun'
                size="sm"
                icon={<AiFillStar size={20} />}
              /></Th>
              <Th w="10%" _hover={{ cursor: "pointer" }} onClick={handleSortCreated}>Creato il  {sortedBy === "created" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "created" && sortOrder === "desc" && <FaSortUp />}</Th>
              <Th w="10%"></Th>
            </Tr>
          </Thead>
          <Tbody>
            {tableContent.map((item) => (
              <Tr key={item.id}>
                <Td>{item.id}</Td>
                <Td title={item.title} whiteSpace="normal" >{item.title}</Td>
                <Td title={item.description} whiteSpace="normal" overflowX="hidden" overflow="hidden" textOverflow="ellipsis" >{item.description}</Td>
                <Td title={item.long_description}  overflowX="hidden" overflow="hidden" textOverflow="ellipsis" >{item.long_description}</Td>
                <Td title={item.category_name} whiteSpace="normal" overflowX="hidden" overflow="hidden" textOverflow="ellipsis">{item.category_name}</Td>
                <Td>{item.premium === 1 ? <Badge variant='subtle' colorScheme='green'>
                  Sì
                </Badge> : <Badge variant='subtle' colorScheme='red'>
                  No
                </Badge>}</Td>
                <Td>{item.hidden === 1 ? <Badge variant='subtle' colorScheme='green'>
                  Sì
                </Badge> : <Badge variant='subtle' colorScheme='red'>
                  No
                </Badge>}</Td>
                <Td>{item.toplist === 1 ? <Badge variant='subtle' colorScheme='green'>
                  Sì
                </Badge> : <Badge variant='subtle' colorScheme='red'>
                  No
                </Badge>}</Td>
                <Td>{item.created_at}</Td>
                <Td><IconButton
                  mr="2"
                  colorScheme='red'
                  aria-label='Call Segun'
                  size='sm'
                  icon={<MdDelete />}
                  onClick={() => { openDelete(item.id, item.title) }}
                />
                  <IconButton
                    mr="2"
                    colorScheme='orange'
                    aria-label='Call Segun'
                    size='sm'
                    icon={<MdEdit />}
                    onClick={() => {
                      setIdToUpdate(item.id);
                      openEdit(item.id, item.title, item.description, item.long_description, item.premium === 1, item.hidden === 1, item.id_category, item.category_name, item.toplist === 1, item.image_path, item.external_path, item.vimeo_link)
                    }}
                  /></Td>
              </Tr>
            ))}

          </Tbody>
          <Tfoot>
            <Tr>
              <Th w="2%">ID</Th>
              <Th w="18%" _hover={{ cursor: "pointer" }} onClick={handleSortTitle}>Titolo   {sortedBy === "title" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "title" && sortOrder === "desc" && <FaSortUp />}</Th>
              <Th w="12%" >Sottotitolo</Th>
              <Th w="12%" >Descrizione</Th>
              <Th w="10%" _hover={{ cursor: "pointer" }} onClick={handleSortTitle}>Categoria    {sortedBy === "category" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "category" && sortOrder === "desc" && <FaSortUp />}</Th>
              <Th w="3%"><IconButton
                colorScheme='orange'
                aria-label='Call Segun'
                size="sm"
                icon={<HiOutlineBadgeCheck size={20} />}
              /></Th>
              <Th w="3%"><IconButton
                colorScheme='yellow'
                aria-label='Call Segun'
                size="sm"
                icon={<AiFillEye size={20} color="white" />}
              /></Th>
              <Th w="3%"><IconButton
                colorScheme='green'
                aria-label='Call Segun'
                size="sm"
                icon={<AiFillStar size={20} />}
              /></Th>
              <Th w="10%" _hover={{ cursor: "pointer" }} onClick={handleSortCreated}>Creato il   {sortedBy === "created" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "created" && sortOrder === "desc" && <FaSortUp />}</Th>
              <Th w="5%"></Th>
            </Tr>

          </Tfoot>

        </Table>

      </TableContainer>}


      <Center w="100%" mb="4">
        <IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          onClick={() => {
            if (page > 1) {
              setTableContent(allData.slice((page * 7) - 14, (page * 7) - 7));
              setPage(page - 1);
            }
          }}
          icon={<AiFillStepBackward />}
        />
        <Text ml="4" mr="4">
          {allData.length > 0 ? page : 0} / {Math.ceil(allData.length / 7)}
        </Text>
        <IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          onClick={() => {
            if (page < Math.ceil(allData.length / 7)) {
              setTableContent(allData.slice((page * 7), (page * 7) + 7));
              setPage(page + 1);
            }
          }}
          icon={<AiFillStepForward />}
        />
      </Center>

      {/* END - TABLE */}

      {/* BEGIN - LOADING */}
      {loading &&

        <Box
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          backgroundColor="rgba(0, 0, 0, 0.5)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex={9999}
          pointerEvents="none">
          <Box
            h="300"
            w="300"
            borderRadius="md"
            backgroundColor="white"
            zIndex={9999}
            display="flex"


          >
            <Flex h="300px" alignItems="center" justifyContent="center">
              <Stack spacing={5} w="300px">
                <Center>
                  <Text fontSize="xl" as="b" color="teal">Caricamento video</Text>
                </Center>
                <Center >
                  <Spinner
                    thickness='4px'
                    speed='0.65s'
                    emptyColor='gray.200'
                    color='blue.500'
                    size='xl'
                  />
                </Center>
                <Center>
                  <Progress hasStripe w="280px" value={updatedChunks / totalChunks * 100} max={100} />
                </Center>
                <Text>Parti caricate</Text>
                <span>{updatedChunks}/{totalChunks}</span>
              </Stack>
            </Flex>
          </Box>
        </Box>
      }

      {/* END - LOADING */}
    </div>

  );

}

export default VideoList;